import React from "react";
import '@fortawesome/fontawesome-free/css/all.css';
import Location from "../Images/Location.gif";
import Phone from "../Images/Phone.gif";
import Email from "../Images/EmailAnim.gif";
import "../CSS/Footer.css";

const Footer1=()=>{
    return(
        <footer className="ftco-footer ftco-section img Footer1" style={{backgroundColor:"#F8D1C9"}}>
    <div className="overlay" />
    <div className="container">
      <div className="row mb-5">
        <div className="col-md-4">
          <div className="ftco-footer-widget mb-4">
            <h2 className="ftco-heading-2">About Us</h2>
            <p className="text-justify">
            Welcome to Janushree Beauty Parlour, where beauty meets elegance! We offer a serene space with personalized beauty and grooming services to make you look and feel your best.
            </p>
            <ul className="ftco-footer-social list-unstyled float-md-left float-lft mt-5">
              <li className="ftco-animate">
                <a  href="https://www.facebook.com/share/CJ6y7xpSBrFxXThS/?mibextid=qi2Omg" target="_blank" className="social-button social-button--facebook">
                <i className="fab fa-facebook-f"></i>
                </a>
              </li>
              <li className="ftco-animate">
                <a href="#" className="social-button social-button--youtube">
                  <i className="fab fa-youtube"></i>
                </a>
              </li>
              <li className="ftco-animate">
                <a href="https://www.instagram.com/janushree_ladiessalon/"  target="_blank"  className="social-button social-button--instagram">
                <i className="fab fa-instagram"></i>
                </a>
              </li>
            </ul>
          </div>
        </div>
       
        <div className="col-md-2">
          <div className="ftco-footer-widget  ml-md-4">
            <h2 className="ftco-heading-2">Services</h2>
            <ul className="list-unstyled">
              <li>
                <a href="#" className="py-2 d-block">
                  Kids Cut
                </a>
              </li>
             
              <li>
                <a href="#" className="py-2 d-block">
                  Hair Cut
                </a>
              </li>
              <li>
                <a href="#" className="py-2 d-block">
                  Hand Care
                </a>
              </li>
              <li>
                <a href="#" className="py-2 d-block">
                  Leg Care
                </a>
              </li>
              <li>
                <a href="#" className="py-2 d-block">
                  Hair Care
                </a>
              </li>
             
            </ul>
          </div>
        </div>
        <div className="col-md-2">
          <div className="ftco-footer-widget  mb-4">
          <h2 className="ftco-heading-2 mb-4"></h2>
            <ul className="list-unstyled" style={{paddingTop:"35px"}}>
            <li>
                <a href="#" className="py-2 d-block">
                  Grey Coverage
                </a>
              </li>
              <li>
                <a href="#" className="py-2 d-block">
                  Coloring
                </a>
              </li>
              <li>
                <a href="#" className="py-2 d-block">
                  Hair Treatment
                </a>
              </li>
              <li>
                <a href="#" className="py-2 d-block">
                  Reflexology
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="col-md-4">
          <div className="ftco-footer-widget mb-4">
            <h2 className="ftco-heading-2">Address</h2>
            <div className="block-23 mb-3">
              <ul>
                <li>
                <h6>Sholinganallur Branch</h6>
                <a href="https://www.google.com/maps/place/Janushree+Ladies+Salon/@12.9014472,80.1768645,7861m/data=!3m1!1e3!4m10!1m2!2m1!1sJanushree+Beauty+Parlour!3m6!1s0x3a525c1cf454af75:0xc176081c1277dede!8m2!3d12.9022911!4d80.2282006!15sChhKYW51c2hyZWUgQmVhdXR5IFBhcmxvdXKSAQxiZWF1dHlfc2Fsb27gAQA!16s%2Fg%2F1ydxc6k5y!5m1!1e1?entry=ttu&g_ep=EgoyMDI0MDkxOC4xIKXMDSoASAFQAw%3D%3D">
                <img 
                  src={Location} 
                  alt="Email Icon" 
                  style={{ width: '30px', marginRight: '5px' }} 
                  />
                  <span className="text" style={{color:"black", paddingLeft:"5px"}}>
                    Rajiv Gandhi Salai, Sholinganallur, Chennai
                  </span>
                  </a>
                </li>
                <li>
                <h6>Medavakkam Branch</h6>
                <a href="https://www.google.com/maps/place/Janushree+Beauty+Saloon/@12.9106985,80.1710122,7182m/data=!3m1!1e3!4m10!1m2!2m1!1sjanushree+beauty+parlour!3m6!1s0x3a525c1c199a2ae5:0x9d1e2123cd20b812!8m2!3d12.9109684!4d80.1915332!15sChhqYW51c2hyZWUgYmVhdXR5IHBhcmxvdXKSAQxiZWF1dHlfc2Fsb27gAQA!16s%2Fg%2F11cm6brwcz?entry=ttu&g_ep=EgoyMDI0MTEyNC4xIKXMDSoASAFQAw%3D%3D">
                <img 
                  src={Location} 
                  alt="Email Icon" 
                  style={{ width: '30px', marginRight: '5px' }} 
                  />
                  <span className="text" style={{color:"black", paddingLeft:"5px"}}>
                    200-A, Mambakkam - Medavakkam Main Rd, Medavakkam, Chennai
                  </span>
                  </a>
                </li>
                <li>
                <a href="tel:+919841424435">
                <img 
                  src={Phone} 
                  alt="Email Icon" 
                  style={{ width: '30px', marginRight: '5px' }} 
                  /> 
                  <span className="text" style={{ paddingLeft:"5px"}}>+91 98414 24435</span>
                </a>
              </li>
              <li>
                <a href="mailto:janushree1515r@gmail.com">
                <img 
                  src={Email} 
                  alt="Email Icon" 
                  style={{ width: '30px', marginRight: '5px' }} 
                  />
                  <span className="text"  style={{ paddingLeft:"5px"}}>janushree1515r@gmail.com</span>
                </a>
              </li>

              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-12 text-center">
          <p>
            {/* Link back to Colorlib can't be removed. Template is licensed under CC BY 3.0. */}
            Copyright © All rights reserved | Created {" "}
            <i className="icon-heart" aria-hidden="true" /> by{" "}
            <a href="https://www.datadna.in/" target="_blank">
              DATADNA
            </a>
            {/* Link back to Colorlib can't be removed. Template is licensed under CC BY 3.0. */}
          </p>
        </div>
      </div>
    </div>
  </footer>
    );
}

export default Footer1;